import { render } from "./SignersEdit.vue?vue&type=template&id=2c7961a2"
import script from "./SignersEdit.vue?vue&type=script&lang=js"
export * from "./SignersEdit.vue?vue&type=script&lang=js"

import "./SignersEdit.vue?vue&type=style&index=0&id=2c7961a2&lang=css"

import exportComponent from "/home/runner/work/Smart2Docs_Front-end/Smart2Docs_Front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__